require('../../vendor/jquery.hoverdir');
const $ = jQuery;

if($('.image-grid').length) {

    if($(window).width() > 991) {
        $('.image-grid-item').hoverdir({ hoverElem: '.overlay' });
    }

    let slideshowContainer = $('.image-grid-slideshow-container').slick({

    });

    $('.image-grid-item').on('click keydown', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
        if (e.key === ' ') e.preventDefault();
        e.preventDefault();

        $('#imageGridSlideshowModal').modal('show');

        // slideshowContainer.slick('refresh');

        setTimeout(() => {
            slideshowContainer.slick('slickGoTo', $(this).data('grid-index'), true);
        }, 300);
    });

}
